// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"eU-z","smallCardRow":"fU-z","largeCardRow":"gU-z","productSearchRow":"hU-z","curatedRow":"iU-z"};